import { Route, Routes, useLocation } from "react-router-dom";
import { RootLayout } from "./layouts/RootLayout";
import { PublicDocLayout } from "./layouts/PublicDocLayout";
import { AboutPage } from "./pages/AboutPage";
import { GearsPage } from "./pages/GearsPage";
import { HomePage } from "./pages/HomePage";
import { MathPage } from "./pages/MathPage";
import { MembershipPage } from "./pages/MembershipPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { PublicDocPage } from "./pages/PublicDocPage";
import { SecurityPage } from "./pages/SecurityPage";
import { RoomPage } from "./pages/RoomPage";
import { SealPage } from "./pages/SealPage";
import { SupporterIdeaVoterPage } from "./pages/SupporterIdeaVoterPage";

export function App() {
	const location = useLocation();
	return (
		<Routes location={location} key={location.pathname}>
			<Route element={<RootLayout />}>
				<Route path="/" element={<HomePage />} />
				<Route path="/r/:roomId" element={<RoomPage />} />
				<Route path="/c/:roomId/:curatorToken" element={<SealPage />} />
				<Route path="/about" element={<AboutPage />} />
				<Route path="/math" element={<MathPage />} />
				<Route path="/privacy" element={<PrivacyPage />} />
				<Route path="/security" element={<SecurityPage />} />
				<Route path="/gears" element={<GearsPage />} />
				<Route path="/membership" element={<MembershipPage />} />

				<Route path="/help" element={<PublicDocLayout variant="help" />}>
					<Route index element={<PublicDocPage />} />
					<Route path="getting-started" element={<PublicDocPage />} />
					<Route path="running-a-session" element={<PublicDocPage />} />
					<Route path="consensus-and-charts" element={<PublicDocPage />} />
					<Route path="slack" element={<PublicDocPage />} />
					<Route path="jira" element={<PublicDocPage />} />
					<Route path="clickup" element={<PublicDocPage />} />
					<Route path="asana" element={<PublicDocPage />} />
					<Route path="teams" element={<PublicDocPage />} />
					<Route path="admin" element={<PublicDocPage />} />
					<Route path="admin/uat-install" element={<PublicDocPage />} />
					<Route path="admin/uat-install/slack" element={<PublicDocPage />} />
					<Route path="admin/uat-install/jira" element={<PublicDocPage />} />
					<Route path="admin/uat-install/clickup" element={<PublicDocPage />} />
					<Route path="admin/uat-install/asana" element={<PublicDocPage />} />
					<Route path="admin/uat-install/web" element={<PublicDocPage />} />
					<Route path="troubleshooting" element={<PublicDocPage />} />
					<Route path="install" element={<PublicDocPage />} />
					<Route path="install/web" element={<PublicDocPage />} />
					<Route path="install/slack" element={<PublicDocPage />} />
					<Route path="install/jira" element={<PublicDocPage />} />
					<Route path="install/clickup" element={<PublicDocPage />} />
					<Route path="install/asana" element={<PublicDocPage />} />
					<Route path="install/microsoft-teams" element={<PublicDocPage />} />
				</Route>

				<Route path="/trust" element={<PublicDocLayout variant="trust" />}>
					<Route index element={<PublicDocPage />} />
					<Route path="security" element={<PublicDocPage />} />
					<Route path="privacy" element={<PublicDocPage />} />
					<Route path="data-processing" element={<PublicDocPage />} />
					<Route path="compliance" element={<PublicDocPage />} />
					<Route path="vulnerability-disclosure" element={<PublicDocPage />} />
				</Route>

				<Route path="/:teamSlug/:ideaSlug" element={<SupporterIdeaVoterPage />} />
			</Route>
		</Routes>
	);
}
